export default "__VITE_ASSET__820a441f__"